import React, {useEffect, useState} from 'react'
import FailedModal from "../../../../../CustomModal/Failed";
import Loader from "../../../../../../Loader/Loader";
import DashboardMenu from "../../../../../layout/dashboardMenu";
import Header from "../../../../../layout/header";
import useLatLng from "../../../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import DistanceCalculator from "../../../../../DistanceCalculator/Calculator";
import Moment from 'moment';
import useSiteDistance from "../../../../../../hooks/currentlocation/useSiteDistance";

const UCDLeadActivitySave = ({
                          newActivityDealerLead,
                          history,
                          match,
                          markAttendancesDealerLead,
                          getActivityDealerLead,
                          getActivityDetails = [],
                          NewActivityDetails = [],
                          userCheckoutDealerLead,
                          isCheckoutDetails = [],
                          markAttendanceDetails = [],
                          activityTypesDetails = [],
                          activityTypes,
                          documentUploadUrlPublic,
                          documentUrlDataPublic=[],
                          getLeadById,
                          leadById=[]
                      }) => {

    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        next_activity_type_id: '',
        activity_date: '',
        lat: '',
        long: '',
        description: '',
        module_type: '',
        lead_id: '',
        meta_data:{}
    }])
    const [openCheckIn, setOpenCheckIn] = useState(false)
    const [checkInId, setCheckInId] = useState(0)
    const [isActivityCreated, setIsActivityCreated] = useState(false)
    const [checkInText, setCheckInText] = useState('Check In')
    const [activityTypeId, setActivityTypeId] = useState('')
    const [distance, setDistance] = useState(0)
    const [currentDate, setCurrentDate] = useState(now.toISOString().slice(0, 16))
    const [showSelfie, setShowSelfie] = useState(true)
    const [hideCheckIn, setHideCheckIn] = useState(false)
    let siteDistance = useSiteDistance(
        leadById?.data?.latitude,
        leadById?.data?.longitude
    )

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getActivityDealerLead(match?.params?.id)
            await userCheckoutDealerLead(match?.params?.id, 'UCD')
            await activityTypes('is_ucd')
            await getLeadById(match?.params?.id)
            setIsLoading(false)
            var today = new Date();
            today.setHours(today.getHours() + 4);
        })()
    }, [])

    useEffect(() => {
        if (parseInt(activityTypeId) === 16 && getActivityDetails?.data !== undefined) {
            // if all activity is completed then show popup check in for new activity
            if (Object.keys(getActivityDetails?.data).length === 0) {
                setOpenCheckIn(true)
                setCheckInText("Check In")
            }
        }
    }, [getActivityDetails, activityTypeId])


    useEffect(() => {
        // after check in hide popup
        if (markAttendanceDetails?.data && markAttendanceDetails?.status === 200) {
            setOpenCheckIn(false)
            setCheckInId(markAttendanceDetails?.data?.id)
            toast.success("Attendance is marked successfully")
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)
            if (checkInText === 'Check out') {
                window.location.href = `ucd-lead-activity-list/${match?.params?.id}`
            }
        }else if(markAttendanceDetails?.data !== undefined && markAttendanceDetails?.status !== 200){
            toast.warning(markAttendanceDetails?.message);
        }
    }, [markAttendanceDetails])

    const handleInput = (key, val, metaKey, e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        if (NewActivityDetails?.status === 200) {
            toast.success(NewActivityDetails?.message)
            if (checkInText === 'Check In') {
                window.location.href = `ucd-lead-activity-list/${match?.params?.id}`
            }
            window.location.href = `ucd-lead-activity-list/${match?.params?.id}`
        } else if (NewActivityDetails?.status !== undefined && NewActivityDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [NewActivityDetails])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        // list['next_activity_type_id'] = new Date();
        list['lead_id'] = match?.params?.id
        list['module_type'] = "UCD"
        list['lat'] = siteDistance?.curr_lat ?? islatlng?.lat
        list['long'] = siteDistance?.curr_long ?? islatlng?.lng
        list['attendance_id'] = checkInId
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;
        list['next_activity_date'] = currentDate
        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }

        if (isActivityCreated && list['next_activity_type_id'] !== '') {
            toast.error("Please complete your pending activity before creating new one.")
            return false
        }
        // console.log("listlistlist "+JSON.stringify(list))
        // return false
        setIsLoading(true)
        await newActivityDealerLead(list)
        setIsLoading(false)
    }


    useEffect(() => {
        // check if user already marked check in but not created any activity then allow to create when user come back
        if (isCheckoutDetails?.data !== undefined && getActivityDetails?.data !== undefined) {
            if (isCheckoutDetails?.data?.activity_id === null && Object.keys(getActivityDetails?.data).length === 0) {
                setOpenCheckIn(false)
                setIsActivityCreated(false)
            } else if (isCheckoutDetails?.data?.check_out_lat === null && Object.keys(getActivityDetails?.data).length === 0) {
                setOpenCheckIn(true)
                setCheckInId(isCheckoutDetails?.data?.id)
                setHideCheckIn(false)
                setCheckInText("Check out")
                setShowSelfie(false)
            }
        }
    }, [isCheckoutDetails, getActivityDetails])

    useEffect(() => {
        if (parseInt(activityTypeId) === 16 && isCheckoutDetails?.data !== undefined && isCheckoutDetails?.data?.check_out_lat === null) {
            setOpenCheckIn(false)
        }
    }, [activityTypeId])


    useEffect(() => {
        setHideCheckIn(false)
        if (leadById?.data !== undefined && leadById?.data?.longitude !== undefined ) {
            let distance = 0;
            if(siteDistance?.distance_in_km !== undefined && siteDistance?.distance_in_km !== 'NaN'){
                distance = siteDistance?.distance_in_km * 1000;
            }
            // console.log(checkInText)
            if(distance > 300 && checkInText === 'Check In'){
                setHideCheckIn(true)
            }
            setDistance(" " + parseFloat(distance).toFixed(2) + " meter away from site")
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)

        }
    }, [leadById, siteDistance])



    return (
        <>
            <FailedModal
                isOpen={isFailedModalOpen}
                msg={NewActivityDetails?.message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {openCheckIn ?
                                <div className="popup-box">
                                    <div className="box">
                                        <DistanceCalculator
                                            isMapShow={true}
                                            calculateDistance={markAttendancesDealerLead}
                                            moduleType={'UCD'}
                                            checkInText={checkInText}
                                            // moduleId={match?.params?.id}
                                            column={'lead_id'}
                                            documentUrlDataPublic={documentUrlDataPublic}
                                            documentUploadUrlPublic={documentUploadUrlPublic}
                                            showSelfie={true}
                                            hideCheckButton={hideCheckIn}
                                            distance={distance}
                                            lat={leadById?.data?.latitude}
                                            long={leadById?.data?.longitude}
                                            leadId={match?.params?.id}
                                        />
                                    </div>
                                </div> :
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100">
                                                        <span style={{color: "green"}}>{distance}</span>
                                                    </h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {handleInput('next_activity_type_id', e.target.value, '', e)}}
                                                                    required={true}
                                                                >
                                                                    <option
                                                                        value="">Select meeting
                                                                    </option>
                                                                    {activityTypesDetails?.data !== undefined && activityTypesDetails?.data.map((val) => {
                                                                        return (
                                                                            <>
                                                                                <option
                                                                                    value={val?.id}>{val.name}
                                                                                </option>
                                                                            </>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Schedule Activity
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <input type="datetime-local"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, e)
                                                                           setCurrentDate(e.target.value)
                                                                       }}
                                                                       id="validationCustom01"
                                                                       min={new Date().toISOString().split('T')[0] + "T00:00"}
                                                                       value={currentDate}
                                                                       disabled={true}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Activity Date
                                                                </label>
                                                            </div>

\
                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value, '', e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required={true}
                                                            />
                                                                <label className="large-label float-lb">
                                                                    {/*Description*/}
                                                                </label>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                {/*</div>*/}
                                                <div className="col-md-12 mt-4 d-flex">
                                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UCDLeadActivitySave

